import { useState } from "react";
import CardCarousel from "./CardCarousel";
import s from "../../TourDetails/TourDetails.module.scss";
import titleImage from "../../../assets/images/titleImage.png";
import { faCrown, faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TopAndRecommend = ({ customSections = [] }) => {
    const [activeTab, setActiveTab] = useState(
        customSections[0]?.slug || ""
    );

    return (
        <div className="row mt-5">
            <div className="col-12">
                <h2>
                    <img className={s.titleImage} src={titleImage} />
                    ケアンズツアーおすすめ
                </h2>
            </div>

            <div className="col-12">

                {/* TAB BUTTONS */}
                <ul className="nav nav-tabs">
                    {customSections.map((section, index) => (
                        <li className="nav-item" key={section.id}>
                            <button
                                className={`nav-link ${s.tabName} ${
                                    activeTab === section.slug ? "active" : ""
                                }`}
                                onClick={() => setActiveTab(section.slug)}
                            >
                                <FontAwesomeIcon
                                    icon={index === 0 ? faCrown : faStar}
                                />{" "}
                                {section.name}
                            </button>
                        </li>
                    ))}
                </ul>

                {/* TAB CONTENT */}
                <div className="tab-content p-3 border border-top-0">
                    {customSections.map((section) =>
                        activeTab === section.slug ? (
                            <div
                                key={section.id}
                                className="tab-pane fade show active"
                            >
                                <CardCarousel tours={section.tours} />
                            </div>
                        ) : null
                    )}
                </div>

            </div>
        </div>
    );
};

export default TopAndRecommend;